var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 746.46 108.64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:url(#linear-gradient-2);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 54.32,
    x2: 98.54,
    y2: 54.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2ae1b6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1fcdee"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 81.57,
    y1: 77.48,
    x2: 102.97,
    y2: 77.48,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M79.63,5.88A55.34,55.34,0,0,0,54.81,0,54.7,54.7,0,0,0,16.05,15.91a54,54,0,0,0,0,76.82,54.7,54.7,0,0,0,38.76,15.91h21.4V68.23L54.81,85.44A31.12,31.12,0,1,1,79.87,35.58l18.67-14A55.06,55.06,0,0,0,79.63,5.88Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "81.56 63.52 81.56 108.64 102.97 108.64 102.97 46.31 81.56 63.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.92,56.68c0-18.07,11.61-31.42,29.94-31.42,15.71,0,24.78,9.16,25.66,21.47H197c-.87-7.33-5.84-12.13-14.75-12.13h-.87c-11.7,0-19,8.46-19,22.08s7.33,22.08,19,22.08h.87c9,0,15.36-5.24,16.5-12.66l.09-1h-17V55.72h18.67c4.8,0,7.42,2.61,7.42,7.42V87.22h-9.16V80.85C196,84.17,190.24,88.1,181,88.1,163.27,88.1,151.92,74.74,151.92,56.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.71,87.22V26.13h26.8c11.61,0,19.64,6.89,19.64,18.94S276.12,64,264.51,64H248.19V87.22Zm10.48-32.55h15c6.81,0,10.47-3.67,10.47-9.6s-3.66-9.6-10.47-9.6h-15Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.87,87.22,344.11,72.3H317L311.2,87.22H300.29l24.18-61.09h12.65l23.74,61.09ZM320.54,62.87h19.9L330.49,37Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.35,87.22V26.13h27.49c10.82,0,18.94,7,18.94,16.58,0,7.77-3.84,13.18-10.21,15.45,6.72,0,9.34,2.88,9.34,8.64V87.22H421.43V69.42c0-4.54-1.31-5.85-5.84-5.85H396.82V87.22Zm10.47-32.9h14.4c7.25,0,11.09-3.93,11.09-9.77,0-6-3.84-9.08-11.09-9.08h-14.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.33,87.22V26.13h45.56v9.34H473.8V51.18h29.85v9.34H473.8V77.89h36v9.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578,26.13h10.47V87.22h-14L548.6,39.75V87.22H538.12V26.13h14L578,73.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.37,56.68c0-18.42,10.65-31.42,29.07-31.42,14.83,0,24.26,8.64,25.13,20.59H661.1c-1.14-7-6.46-11.25-14.23-11.25H646c-11.17,0-18.15,9-18.15,22.08s7,22.08,18.15,22.08h.87c7.77,0,13.09-4.19,14.23-11.26h10.47c-.87,12.13-10.3,20.6-25.13,20.6C628,88.1,617.37,75.09,617.37,56.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M713.64,87.22V62.44L691.3,26.13h12l15.88,26.18,15.71-26.18h11.61L724.12,62.44V87.22Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.a9652e1cc8bff12fca521194648b2d2e.svg";
export { ForwardRef as ReactComponent };